import axios from "axios";
import {
	ROOM_LOADING,
	ROOM_VALIDATION_SUCCESS,
	ROOM_LEAVE,
	ROOM_ERROR,
	ROOM_CLEAR_ERROR,
	ROOM_SENT_MESSAGE,
} from "./actionTypes";

function roomLoading() {
	return { type: ROOM_LOADING };
}

function roomSucess(_id, roomName, messages) {
	return {
		type: ROOM_VALIDATION_SUCCESS,
		payload: { _id, roomName, messages },
	};
}

function roomSentMessage(_id, username, message, date) {
	return {
		type: ROOM_SENT_MESSAGE,
		payload: { _id, username, message, date },
	};
}

function roomError(error) {
	return { type: ROOM_ERROR, payload: { error } };
}

export function roomLeave() {
	return { type: ROOM_LEAVE };
}

export function clearError() {
	return { type: ROOM_CLEAR_ERROR };
}

// @route				POST /room/create
// @desc				creating a chat room
// @access				public
// @parameters			{ roomName, password }
// @res.data			{ _id, roomName, messages } || { err }
// @possible errors		{ err: "Missing field" } || { err: "Chat already exist" }
export function roomCreate(roomName, password) {
	return dispatch => {
		dispatch(roomLoading());
		const date = new Date();
		axios
			.post("/room/create", { roomName, password, date })
			.then(res => {
				const { _id, roomName, messages } = res.data;
				dispatch(roomSucess(_id, roomName, messages));
			})
			.catch(err => dispatch(roomError(err.response.data.err)));
	};
}

// @route				POST /room/join
// @desc				joining a chat room
// @access				public
// @parameters			{ roomName, password }
// @res.data			{ _id, roomName, messages } || { err }
// @possible errors		{ err: "Missing field" } || { err: "Chat doesn't exist" } || { err: "Invalid password" }
export function roomJoin(roomName, password) {
	return dispatch => {
		dispatch(roomLoading());
		axios
			.post("/room/join", { roomName, password })
			.then(res => {
				const { _id, roomName, messages } = res.data;
				dispatch(roomSucess(_id, roomName, messages));
			})
			.catch(err => dispatch(roomError(err.response.data.err)));
	};
}

// @route	POST /room/msg
// @desc	append messages
// @access	public
export function chatMessage(_id, username, message, date) {
	return dispatch => {
		const token = localStorage.getItem("auth-token");

		axios
			.patch("/room/message", { _id, username, message, date }, { headers: { "x-auth-token": token } })
			.then(res => {
				// console.log(res.data);
				// console.log(`[Message Sent] Username: ${username} Message: ${message}`);
				console.log(_id, username, message, date);
				dispatch(roomSentMessage(_id, username, message, date));
			})
			.catch(err => console.log(err.message));
	};
}
